import { Box, Button, styled } from '@mui/material';

import { CcfTypography } from '../core/ccf-typography/ccf-typography';

import styles from './ccf-action-editor-selected.module.scss';

export interface CcfActionEditorSelectedProps {
  selections?: any[];
  title?: string;
  label?: string;
  handleDelete?: (selection: any) => void;
  titleStyles?: any;
}

/**
 * Component displays chips based on selections
 * @param props - CcfActionEditorSelectedProps
 * @returns component
 * @example <CcfActionEditorSelected />
 */
export function CcfActionEditorSelected(props: CcfActionEditorSelectedProps) {
  const { selections = [], handleDelete, label, title = '', titleStyles = {} } = props;

  const StyledCcfTypography = styled(CcfTypography)(titleStyles);

  const StyledButton = styled(Button)({
    textAlign: 'center',
    padding: 0,
    margin: 0,
    position: 'relative',
    height: '25px',
    width: '25px',
    minWidth: '25px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  });

  return (
    <Box>
      <StyledCcfTypography>{title}</StyledCcfTypography>

      <Box className={styles.selections}>
        {selections.map((selection, index) => {
          let name = '';

          if (label) {
            switch (typeof selection) {
            case 'object':
              name = selection[label];

              break;
            case 'string':
              name = selection;

              break;
            }
          }

          return (
            <Box className={styles.chip} key={`selected-${index}`}>
              <CcfTypography className={styles.label}>{name}</CcfTypography>

              <StyledButton
                className={styles.remove}
                onClick={() =>
                  handleDelete && typeof handleDelete === 'function' && handleDelete(selection)
                }
              />
            </Box>
          );
        })}
      </Box>
    </Box>
  );
}

export default CcfActionEditorSelected;
